<div class="wiki-banner" *ngIf="wiki?.banner">
	<app-image [natural]="false" [url]="wiki.banner"></app-image>
</div>
<div class="gutter">
	<div class="wiki flx-col" *ngIf="wiki">
		<h1 class="gutter-v-half">{{ wiki?.name }}</h1>
		<app-ve *ngIf="wiki" [content]="wiki.content" [module]="'articles'" [dir]="wiki.photos_directory" (changed)="changeModel($event)"></app-ve>
	</div>
</div>